import * as myFriendsType from './MyFriendsActionTypes';
import * as type from './userActionTypes';

export const loginUserAction = (email, password, rememberMe) => ({
  type: type.LOGIN_USER,
  email,
  password,
  rememberMe,
});

export const setUser = (user, token) => ({
  type: type.SET_USER,
  user,
  token,
});

export const setMessage = (message) => ({
  type: type.SET_MESSAGE,
  message,
});

export const logoutUser = () => ({
  type: type.LOGOUT_USER,
});

export const setSubscription = (subscription) => ({
  type: type.SET_SUBSCRIPTION,
  subscription,
});

export const setLoading = (value) => ({
  type: type.SET_LOADING,
  value,
});

export const getLoggedStudent = () => ({
  type: type.GET_LOGGED_STUDENT,
});

export const requestPasswordAction = (email) => ({
  type: type.REQUEST_PASSWORD,
  email,
});

export const resetPassword = (password, confirmPassword, token) => ({
  type: type.RESET_PASSWORD,
  password,
  confirmPassword,
  token,
});

export const trialUserProgress = (studyId, studyMethod) => ({
  type: type.GET_TRIAL_USER_PROGRESS,
  studyId,
  studyMethod,
});

export const setCantStudy = (cantStudy) => ({
  type: type.SET_CANT_STUDY,
  cantStudy,
});

export const setlastNotificationsRequest = (value) => ({
  type: type.SET_LAST_NOTIFICATIONS_REQUEST,
  value,
});

export const setlastUserNotificationsRequest = (value) => ({
  type: type.SET_LAST_USER_NOTIFICATIONS_REQUEST,
  value,
});

export const updateUserSettingQualForDailyQuiz = (qualId) => ({
  type: type.UPDATE_USER_SETTING_QUAL_FOR_DAILY_QUIZ,
  qualId,
});

export const setUserSettingQualForDailyQuiz = (qualId) => ({
  type: type.SET_USER_SETTING_QUAL_FOR_DAILY_QUIZ,
  qualId,
});

export const setUserSettingQualForDailyQuizMessage = (message) => ({
  type: type.SET_USER_SETTING_QUAL_FOR_DAILY_QUIZ_MESSAGE,
  message,
});

export const setLoadingUpdateUserSettingQualForDailyQuiz = (isLoading) => ({
  type: type.SET_LOADING_UPDATE_USER_SETTING_QUAL_FOR_DAILY_QUIZ,
  isLoading,
});

export const setChangeStudySpeedSettings = (setting) => ({
  type: type.SET_CHANGE_STUDY_SPEED_SETTINGS,
  setting,
});

export const verifyIsMaintenance = () => ({
  type: type.VERIFY_IS_MAINTENANCE,
});
